export default __webpack_public_path__ + "static/media/vDimension.b5052ab3.jpeg";